import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-video-dialog',
    template: `
        <div class="video-container">
            <button class="close-button" (click)="dialogRef.close()">
                <i class="material-icons">close</i>
            </button>
            <iframe
                [src]="getVideoUrl() | safe"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            >
            </iframe>
        </div>
    `,
    styles: [
        `
            .video-container {
                position: relative;
                width: 100%;
                height: 100%;
                background: #000;
            }
            iframe {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
            .close-button {
                position: absolute;
                top: 16px;
                right: 16px;
                z-index: 1000;
                background: rgba(0, 0, 0, 0.6);
                border: none;
                border-radius: 50%;
                width: 40px;
                height: 40px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: background-color 0.2s ease;
            }
            .close-button:hover {
                background: rgba(0, 0, 0, 0.8);
            }
            .close-button i {
                color: white;
                font-size: 24px;
            }
        `,
    ],
})
export class VideoDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<VideoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { videoId: string; videoUrl?: string }
    ) {}

    getVideoUrl(): string {
        if (this.data.videoUrl) {
            return this.data.videoUrl;
        }
        return `https://www.youtube.com/embed/${this.data.videoId}?autoplay=1`;
    }
}
